export default __webpack_public_path__ + "static/media/we-process.c4ffde11.svg";